var map = {
	"./01.jpg": 88517,
	"./010.jpg": 69077,
	"./011.jpg": 86078,
	"./012.jpg": 91838,
	"./013.jpg": 87194,
	"./014.jpg": 32671,
	"./015.jpg": 10277,
	"./016.jpg": 20246,
	"./02.jpg": 31140,
	"./03.jpg": 34220,
	"./04.jpg": 93333,
	"./05.jpg": 78721,
	"./06.jpg": 31033,
	"./07.jpg": 67886,
	"./08.jpg": 2880,
	"./09.jpg": 16995,
	"./default-skin.png": 95958,
	"./default-skin.svg": 2242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25307;